import * as Sentry from "@sentry/vue";
import type { App as VueApp } from "vue";
import { appConfig } from "@/types/appConfig.type.ts";
import type { Router } from "vue-router";

const DSN_SENTRY: string = appConfig.VITE_DSN_SENTRY;
const TRACES_SAMPLE_RATE: number = Number(appConfig.VITE_TRACES_SAMPLE_RATE);
const REPLAYS_SESSION_SAMPLE_RATE: number = Number(
  appConfig.VITE_REPLAYS_SESSION_SAMPLE_RATE,
);
const REPLAYS_ON_ERROR_SAMPLE_RATE: number = Number(
  appConfig.VITE_REPLAYS_ON_ERROR_SAMPLE_RATE,
);
const SENTRY_ENVIRONMENT: string = appConfig.VITE_SENTRY_ENVIRONMENT;

const initializeSentry = (app: VueApp, router: Router) => {
  if (DSN_SENTRY) {
    Sentry.init({
      app,
      dsn: DSN_SENTRY,
      environment: SENTRY_ENVIRONMENT,
      integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        }),
      ],
      tracesSampleRate: TRACES_SAMPLE_RATE,
      replaysSessionSampleRate: REPLAYS_SESSION_SAMPLE_RATE,
      replaysOnErrorSampleRate: REPLAYS_ON_ERROR_SAMPLE_RATE,
    });
  }
};

export default initializeSentry;
